import { ActionTypes } from "store/constants";

export const updateUI = (returnedPayload) => ({
  type: ActionTypes.updateUI.update,
  payload: returnedPayload,
});
